//components
import { RichText } from '@/components/RichText';

//styles
import {
  CardWrapper,
  CardTitle,
  CardTagline,
  CardCopy,
  CardLink,
  SrOnly,
} from './Card.styles';

export function Card({ content }) {
  const paragraphs = Array.isArray(content.description)
    ? content.description
    : [content.description];

  return (
    <CardWrapper>
      <CardTitle>{content.title}</CardTitle>
      {content.tagline && <CardTagline>{content.tagline}</CardTagline>}
      {paragraphs.map((paragraph, index) => (
        <CardCopy key={`${content.title}-p-${index}`}>
          <RichText content={paragraph} />
        </CardCopy>
      ))}
      {content.link && (
        <CardLink
          href={content.link.url}
          {...(content.link.external && {
            target: '_blank',
            rel: 'noreferrer noopener',
          })}
        >
          {content.link.label}
          <SrOnly> about {content.title}</SrOnly>
          <svg
            viewBox="0 0 16 10"
            width="16"
            height="10"
            aria-hidden="true"
            focusable="false"
          >
            <path
              d="M1 5h13m-4-4l4 4-4 4"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </CardLink>
      )}
    </CardWrapper>
  );
}
